function selectColumn(element) {
  console.log("Got to select column with ::", element, "column::", columnName);
  // Get the parent button element
  var columnName = element.innerText;
  var parentButton = element.closest(".dropdown").querySelector(".btn");
  // Set the selected column name as data attribute on the parent button
  parentButton.setAttribute("data-selected", columnName);

  // Update the button label to display the selected column name
  var buttonText = columnName === "none" ? "Select Column" : columnName;
  parentButton.querySelector("div").innerText = buttonText;
}

class ProcessNodesStates {
  resetSessionStorageforDropdowns() {
    console.log("Resetting session Storage for Dropdown");
    sessionStorage["query"] = sessionStorage["blank_session_storage_obj"];
    sessionStorage["raw_string_query_input"] = "";
  }
  initializeSessionStorageforDropdowns() {
    console.log("Calling initializeSessionStorageforDropdowns");
    // console.log(sessionStorage['query']);

    var all_objs = jQuery.extend(org_chart_filters_obj, company_filters_obj, people_filters_obj, {
      company_id: [],
      function_root: [],
      person_id: [],
      active_experience: true,
      checkbox_has_email: false,
      checkbox_has_phone: false,
    });
    sessionStorage["blank_session_storage_obj"] = JSON.stringify(all_objs);
    if (sessionStorage["query"] === undefined) {
      sessionStorage["query"] = sessionStorage["blank_session_storage_obj"];
    }
  }
}

var comboTree1;

var org_chart_filters_obj = {
  website: [],
  company_name: [],
  company_id: [],
  function_root: [],
  country: [],
  company_linkedin_url: [],
  search_in_org_chart: [],
};
var company_filters_obj = {
  industry: [],
  industry_category: [],
  gpt3_company_search: [],
  company_name: [],
  company_id: [],
  website: [],
  company_linkedin_url: [],
  reverse_company: [],
  functions: [],
  function_root: [],
  grades: [],
  company_sizes: [],
  country: [],
  region: [],
  locality: [],
  locality_presence: [],
  region_presence: [],
  country_presence: [],
  locations: [],
  company_type: [],
  founded: [],
  tags: [],
};
var people_filters_obj = {
  person_name: [],
  gpt3_company_search: [],
  company_name: [],
  company_id: [],
  functions: [],
  function_root: [],
  grades: [],
  reverse_job_title: [],
  job_title: [],
  skills: [],
  reverse_company: [],
  locations: [],
  country: [],
  person_linkedin_url: [],
  email_address: [],
  phone_number: [],
  genders: [],
  industry: [],
  school: [],
  education_degrees: [],
  education_majors: [],
  year_of_graduation: [],
};

function callBodyOnloadFunction() {
  console.log("callBodyOnloadFunction function has been called in javascript");
  window.load_type = document.getElementById("load_type").getAttribute("data-row");
  window.user_obj = document.getElementById("user_obj").getAttribute("data-row");
  console.log("This is load type::", window.load_type);
  console.log("This is user_obj ::", window.user_obj);
  // debugger;
  try {
    var use_case = JSON.parse(window.user_obj)["use_case"];
    if (use_case !== "") {
      sessionStorage["use_case"] = use_case;
    }
  } catch (error) {}

  if (window.load_type == "org-chart") {
    // sessionStorage['load_type'] = 'org-chart'
    if (window.location.href.indexOf("/org-chart/") > 0) {
      new Pages().searchPage();

      console.log("Load type is org-chart. Going to draw org charts!!!");
      var flask_jinja_obj = document.getElementById("org_data").getAttribute("data-row");
      // console.log(flask_jinja_obj)
      var parsed_flask_jinja_obj = JSON.parse(flask_jinja_obj);
      console.log(parsed_flask_jinja_obj);
      if (parsed_flask_jinja_obj["query_status"] == "unauthorized") {
        console.log("Some problem");
      } else {
        var org_data = parsed_flask_jinja_obj["results"]["data"]["modified_query_results"];
        console.log(org_data);
        if (org_data.length == 0) {
          new Query().handleIncompleteResponse(parsed_flask_jinja_obj);
        }
        // Checking if this is needed and will worl
        if (window.location.href.split("/org-chart/")[1].length > 0) {
          new DrawOrgCharts().drawOrgchart(org_data);
        }
      }
    }
  } else {
    console.log("Load type is a simple query. Chilling!");
    document.title = "Arxena's Org Charts (Global) - Arxena";
    // sessionStorage['load_type'] = 'query'
  }
}

class Query {
  showWaitForPeopleDataFromExternalSource() {
    console.log("Got to show wait for people from external sources");
    new Modals().seeActivity();
  }

  ifYouCanSetupLoadersinTheRightSide() {
    var loader =
      '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br><span style="font-size:10pt">Searching ...<br>Companies with > 10k employees may take ~20 seconds!</span></div>';
    try {
      document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = loader;
      document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = loader;
    } catch (error) {
      console.log("Error:", error);
    }
  }

  ifYoucanSetupSearchImageonRightSide() {
    document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("start_search_element").innerHTML;
    document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("start_search_element").innerHTML;
  }

  cancelconfirmFetchAllResults() {
    $(fetch_node_results).modal("hide");
    new Tokens().resetFunctionsGradesDropdown();

    sessionStorage["data_source"] = "arxena";
  }

  clearSelectedContextMenu() {
    console.log("Called clearSelectedContextMenu");
    sessionStorage["selected_context_menu"] = "";
  }

  setUpCountQueryResults() {
    var params_obj = updateParamsObj("count_query");
    var user_input = "count_query";
    var query_obj = { query: sessionStorage["query"], params: params_obj };
    console.log("Data Source::", sessionStorage["data_source"]);
    if (sessionStorage["current_focus"] == "people") {
      sessionStorage["sample_people_data"] = "true";
    } else if (sessionStorage["current_focus"] == "companies") {
      sessionStorage["sample_company_data"] = "true";
    }
    if (sessionStorage["data_source"] != "data_broker_1") {
      if (sessionStorage["current_focus"] != "orgcharts") {
        console.log("Calling callBackendQueryExecuteOnResponse for count");
        new Query().callBackendQueryExecuteOnResponse(query_obj, user_input);
      }
    }
  }

  confirmFetchAllNodeContextResults() {
    if ((sessionStorage["data_source"] == "arxena") & (sessionStorage["locations_dropdown1"] == "")) {
      console.log("Not letting go!");
      document.getElementById("pick_function_error_node").innerHTML = '<span style="color:red;text-align:center">Please fill in all requirements</span>';
    } else {
      sessionStorage["consume_credits"] = "true";
      new Query().fetchQueryShowResults("button_query_show_results");
      $(fetch_people_results).modal("hide");
      sessionStorage["consume_credits"] = "false";
      console.log("fetch all rescults confirmed");
    }
  }

  callBackendQueryExecuteOnResponse(query_obj, user_input) {
    console.log("Called callBackendQueryExecuteOnResponse with query_obj::", JSON.parse(query_obj["query"]));
    console.log("Called callBackendQueryExecuteOnResponse with and user input::", user_input);

    console.log("Parsed Query Obj['params']::", JSON.parse(query_obj["params"]), "query:::", JSON.parse(query_obj["query"]), "count query is :::", params["count_query"]);
    console.log("GOING TO HIT QUERY AJAX ENDPOINT!!!!");
    jQuery
      .ajax({
        url: "/query",
        type: "POST",
        data: query_obj,
        error: function (xhr, status) {
          let error_status = xhr.status;
          if (error_status == 429) {
            console.log("Too Many Requests");
            document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
            document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
            new ProcessNodesStates().resetSessionStorageforDropdowns();
          }
          if (error_status == 500) {
            new ProcessNodesStates().resetSessionStorageforDropdowns();
            console.log("There has been an error as error code is 500!!");
            // location.reload();
            stopLoadersFromRotating();
          }
          // alert(xhr.status);
        },
      })
      .done(function (response, statusText, xhr) {
        console.log("Received ajax response:::", response);
        if (response?.status && response.status == "ok") {
          // Might have to add cookie based authentication here
          if ((localStorage["user"] == "{}") & (typeof localStorage["email"] != "undefined") & (sessionStorage["current_focus"] != "orgcharts")) {
            document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("logged_out_empty_element").innerHTML;
            console.log("Going here to set timeout and change page to /login");
            setTimeout("new PageContents().changePage('/login')", 300);
          } else {
            let result = response.result;
            new Query().executeQueryResponse(result, statusText, xhr, user_input);
          }
        } else {
          console.error("when / filters called got this response::", response);
          new PageContents().logOut();
        }
      });
  }

  executeQueryResponse(response, statusText, xhr, user_input) {
    console.log("This is the response to query ::", response, "with user input::::", user_input);
    if ((user_input == "count_query") & (response["status"] != "incomplete")) {
      console.log("Called from executeQueryResponse(response, statusText,xhr, user_input)::");
      console.log(response);
      console.log(statusText);
      console.log(xhr);
      console.log(xhr.status);
      var count_db_results = response["count_db_results"];
      new LoadDataPeopleCompaniesOrgCharts().loadCountResultsinPeopleorCompanies(response, count_db_results);
    } else if (user_input == "raw_string_query_input") {
      if (response["status"] == "success") {
        data = response["results"]["data"]["modified_query_results"];
        updateStorageToken(data, "raw_string_query_input");
        new LoadDataPeopleCompaniesOrgCharts().loadResults(response);
        $(waiting_results_raw_string).modal("hide");
        count_db_results = response["count_db_results"];
        new LoadDataPeopleCompaniesOrgCharts().loadCountResultsinPeopleorCompanies(response, count_db_results);
      } else {
        $(waiting_results_raw_string).modal("hide");
      }
    } else if (user_input == "cost_credits") {
      console.log("Called executeQueryResponse from cost_credits ::");
      // This query is to just get the number of results
      // When response['status'] == 'incomplete', the count db results will be shown to be 0
      console.log(response);
      console.log(statusText);
      console.log(xhr);
      console.log(xhr.status);
      var cost_credits = response["results"]["data"]["modified_query_results"];
      var count_db_results = response["count_db_results"];
      new LoadDataPeopleCompaniesOrgCharts().loadCostCredits(cost_credits, count_db_results);
    } else if (user_input == "boolean_keywords_string") {
      console.log("Called executeQueryResponse from boolean_keywords_string ::");
      console.log(response);
      console.log(statusText);
      console.log(xhr);
      console.log(xhr.status);
      boolean_keywords_string = response;
      new Modals().openBooleanKeywordsModal(boolean_keywords_string);
      sessionStorage["boolean_keywords_string"] = "false";
    } else if (user_input == "contact_info") {
      console.log("Called executeQueryResponse from contact_info ::");
      console.log(response);
      console.log(statusText);
      console.log(xhr);
      console.log(xhr.status);
      new LoadDataPeopleCompaniesOrgCharts().loadContactInfoAnyTypeContactInfo(response, user_input);
    } else if (user_input == "contact_info_org_charts") {
      console.log("Called executeQueryResponse from contact_info_org_charts ::");
      console.log(response);
      console.log(statusText);
      console.log(xhr);
      console.log(xhr.status);
      new LoadDataPeopleCompaniesOrgCharts().loadContactInfoAnyTypeContactInfo(response, user_input);
    } else if (user_input === undefined || user_input == "load_data_without_loading_tokens") {
      console.log("Called executeQueryResponse from load_data_without_loading_tokens ::");
      console.log(response);
      console.log(statusText);
      console.log(xhr.status);
      console.log(response.status);
      if (response["status"] == "success" || response["status"] == "blank") {
        console.log("Called executeQueryResponse from load_data_without_loading_tokens :: and results status is success::", response);
        if (response["query_status"] == "logged_out") {
          new Pages().resetLocalStorageCredentialsAndSetLogonStatus();
          var loggedin = false;
          new PageContents().replaceTopBarandHeaderElementwhenLoggedOut();
          new LeftPanelDropdownFilters().removeLeftPanelforOrgChartwhenLoggedOut();
        }
        // console.log("GOT RESPONSE WITH status is success")
        // console.log("Status is okay")
        var data = response["results"]["data"]["modified_query_results"];

        updateStorageToken(data, "ajaxQuery");
        if (user_input == undefined) {
          // This condition is to ensure that when minus sign tokens are clicked, then left panel tokens are not reloaded. Otherwise it enters infinite loop!!!
          new Tokens().showTokensinUI();
        }
        new LoadDataPeopleCompaniesOrgCharts().loadResults(response);
        console.log("Got here to check typ eof response to check fi we want to load count results in people or companies:::", typeof response, "count_db_results::", count_db_results);
        console.log("Got here to check typ eof response.results.data.modified_query_results:::", response.results);
        if ((typeof response != "undefined") & (response.results.data.modified_query_results.length > 0)) {
          new LoadDataPeopleCompaniesOrgCharts().loadCountResultsinPeopleorCompanies(data, count_db_results);
        }
      } else if (response["status"] == "incomplete") {
        if (response["query_status"] == "unauthorized") {
          console.log("GOT RESPONSE WITH status is unauthorized ,incomplete");
          console.log("Unauthorised access");
          var loader = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br><span style="font-size:10pt">Searching your data...</span></div>';
          if (sessionStorage["load_type"] == "org-chart") {
            document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = loader;
            document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = loader;
            if (sessionStorage["current_focus"] == "people" || sessionStorage["current_focus"] == "companies") {
              document.getElementById("header_element").innerHTML = "";
              document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("not_logged_in").innerHTML.replace("{not_logged_in}", "<br>We have logged you out. Please log back in to continue.</a>");
              document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document
                .getElementById("not_logged_in")
                .innerHTML.replace("{not_logged_in}", "<br>We have logged you out. Please log back in to continue.</a>");
            }
          } else if (sessionStorage["current_focus"] == "people" || sessionStorage["current_focus"] == "companies") {
            // document.getElementById('header_element').innerHTML = ''
            document.getElementById("header_element").innerHTML = document.getElementById("people_header_element").innerHTML;

            document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("not_logged_in").innerHTML.replace("{not_logged_in}", "<br>We have logged you out. Please log back in to continue.</a>");
            document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("not_logged_in").innerHTML.replace("{not_logged_in}", "<br>We have logged you out. Please log back in to continue.</a>");
          } else {
            document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("not_logged_in").innerHTML.replace("{not_logged_in}", "<br>We have logged you out. Please log back in to continue.</a>");
            document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("not_logged_in").innerHTML.replace("{not_logged_in}", "<br>We have logged you out. Please log back in to continue.</a>");
          }
          var loggedin = false;
          new PageContents().replaceTopBarandHeaderElementwhenLoggedOut();
        } else {
          new Query().handleIncompleteResponse(response);
        }
      } else if (response["status"] == "not_ok") {
        console.log("GOT RESPONSE WITH not_ok");

        if (response["request_id"] != "" && response["current_focus"] == "people" && response["source"] == "serp") {
          console.log("Results are SERP and hence we have to ask the user to wait for a bit");
          new Query().showWaitForPeopleDataFromExternalSource();
        } else {
          console.log("Status is not okay");
          console.log("This is the client query obj::");
          console.log(response["request_id"]);
          document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("start_search_element").innerHTML;
          document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("start_search_element").innerHTML;

          new ProcessNodesStates().resetSessionStorageforDropdowns();
        }
      } else if (response["status"] == "out_of_credits") {
        console.log("GOT RESPONSE WITH out_of_credits");

        console.log("This is the client query obj::");
        console.log(response["request_id"]);
        $(out_of_credits_modal).modal("show");
        new ProcessNodesStates().resetSessionStorageforDropdowns();
        new PageContents().changePage("/dashboard");
      }
    } else if (user_input == "button_query_show_results") {
      console.log("GOT RESPONSE WITH button_query_show_results");
      console.log(response);

      if (response["selected_context_menu"] == "fetchCurrentNodeDataResults") {
        console.log("GOT RESPONSE WITH fetchCurrentNodeDataResults");
        console.log(response);
        var node_key = response.response_params.key;
        var node_key = response.response_params.parent;
        var response_nodes = response["results"]["data"]["modified_query_results"];
        processMultipleNodes(response, response_nodes);
        $(waiting_results).modal("hide");
        updateStorageToken({}, "resetOrgChartTokensAfterFetchNodeData");
      } else if (response["selected_context_menu"] == "fetchEntireCompanyDataResults") {
        console.log("GOT RESPONSE WITH fetchEntireCompanyDataResults");
        console.log(response);
        new LoadDataPeopleCompaniesOrgCharts().loadResults(response);
        $(waiting_results_raw_string).modal("hide");
        $(waiting_results).modal("hide");
        // count_db_results = response['count_db_results']
        // loadCountResultsinPeopleorCompanies(response, count_db_results)
      } else if (response["selected_context_menu"] == "fetchAllLeadershipNodes") {
        console.log("GOT RESPONSE WITH fetchAllLeadershipNodes");
        console.log(response);
        var response_nodes = response["results"]["data"]["modified_query_results"];
        processMultipleNodes(response, response_nodes);
        $(waiting_results).modal("hide");
      } else if (response["selected_context_menu"] == "fetchOrgChartFunctionGradeDataResults") {
        console.log("GOT RESPONSE WITH fetchAllLeadershipNodes");
        console.log(response);
        var response_nodes = response["results"]["data"]["modified_query_results"];
        processMultipleNodes(response, response_nodes);
        $(waiting_results).modal("hide");
      } else if (response["selected_context_menu"] == "fetchAllSelectedNodes") {
        console.log("GOT RESPONSE WITH fetchAllSelectedNodes");
        console.log(response);
      } else if (response["selected_context_menu"] == "fetchAllFunctionDataResults") {
        console.log("GOT RESPONSE WITH fetchAllFunctionDataResults");
        console.log(response);
        console.log("GOT RESPONSE WITH fetchEntireCompanyDataResults");
        console.log(response);
        new LoadDataPeopleCompaniesOrgCharts().loadResults(response);
        $(waiting_results_raw_string).modal("hide");
        $(waiting_results).modal("hide");
      } else {
        console.log("GOT RESPONSE WITH changeNodeDataUsingQueryResponse(response, node_key, parent");
        $(waiting_results).modal("hide");
        var node_key = response.response_params.key;
        var parent = response.response_params.parent;
        changeNodeDataUsingQueryResponse(response, node_key, parent);
      }
      sessionStorage["data_source"] = "arxena";
    }
  }

  handleIncompleteResponse(response) {
    console.log("HANDDLING INCOMPLETE RESPONSE!!");
    console.log("GOT RESPONSE WITH Null status is ::", response["query_status"]);
    console.log("Status is incomplete");
    console.log("This is the client query obj::");
    console.log(response["request_id"]);
    var company_employee_count_obj = JSON.parse(sessionStorage["company_emp_counts"]).slice(-1)[0];
    console.log(company_employee_count_obj);
    console.log(window.location.href);
    if (response["query_status"] == "no_credits") {
      document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document
        .getElementById("no_results_message")
        .innerHTML.replace("{no_results_message}", "<br>Apologies but you need to recharge your credits for further searches. Please recharge from the dashboard or email support at data@arxena.com and we will help immediately.</a>");
      document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document
        .getElementById("no_results_message")
        .innerHTML.replace("{no_results_message}", "<br>Apologies but you need to recharge your credits for further searches. Please recharge from the dashboard or email support at data@arxena.com and we will help immediately.</a>");
      console.log(response["request_id"]);
      $(out_of_credits_modal).modal("show");
      new ProcessNodesStates().resetSessionStorageforDropdowns();
      new PageContents().changePage("/dashboard");
    } else {
      if (company_employee_count_obj === undefined) {
        if (sessionStorage["current_focus"] == "orgcharts") {
          var company_name_requested = window.location.href.split("/").slice(-1)[0];
          document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document
            .getElementById("no_results_message")
            .innerHTML.replace("{no_results_message}", "<br>Apologies but we havent yet loaded the chart for " + company_name_requested + " <br> Please email support at data@arxena.com and we will help immediately.</a>");
          document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document
            .getElementById("no_results_message")
            .innerHTML.replace("{no_results_message}", "<br>Apologies but we havent yet loaded the chart for " + company_name_requested + " <br> Please email support at data@arxena.com and we will help immediately.</a>");
        } else {
          document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document
            .getElementById("no_results_message")
            .innerHTML.replace("{no_results_message}", "<br>Apologies but we couldn't load the requested data at this time <br> Please email support at data@arxena.com and we will help immediately.</a>");
          document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document
            .getElementById("no_results_message")
            .innerHTML.replace("{no_results_message}", "<br>Apologies but we couldn't load the requested data at this time <br> Please email support at data@arxena.com and we will help immediately.</a>");
        }
      } else {
        company_name_requested = company_employee_count_obj["company_id_label"];
        document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document
          .getElementById("no_results_message")
          .innerHTML.replace(
            "{no_results_message}",
            "<br>Apologies but we havent yet loaded the chart for " + company_name_requested + " <br> Please email support at data@arxena.com and we will load it with " + company_employee_count_obj["company_emp_count"] + " employee profiles.</a>"
          );
        document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document
          .getElementById("no_results_message")
          .innerHTML.replace(
            "{no_results_message}",
            "<br>Apologies but we havent yet loaded the chart for " + company_name_requested + " <br> Please email support at data@arxena.com and we will load it with " + company_employee_count_obj["company_emp_count"] + " employee profiles.</a>"
          );
      }
    }
  }

  fetchQueryShowResults(user_input) {
    console.log("Called fetchQueryShowResults with the user input:::", user_input, "and data source after fetchQueryShowResults", sessionStorage["data_source"]);
    var loader2 = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/></div>';
    if (user_input === undefined || user_input == "load_data_without_loading_tokens") {
      console.log("This the user input and it is undefined ::", user_input);
      // blank_session_storage_obj = '{"raw_text":[],"company_id":[],"company_name":[],"functions":[],"industry":[],"grades":[],"position":[],"year_founded":[],"country":[],"location":[],"linkedin_url":[],"gender":[],"job_title":[]}'
      var blank_session_storage_obj = sessionStorage["blank_session_storage_obj"];
      if (sessionStorage["query"] != blank_session_storage_obj || sessionStorage["company_id"] != undefined) {
        console.log("Tokens list is not equal to blank session Object");
        console.log("sending query for ajax query  in  fetchQueryShowResults inside first load_data_without_loading_tokens");
        new Query().ifYouCanSetupLoadersinTheRightSide();
        var params_obj = updateParamsObj("ajax_query");
        var query_obj = { query: sessionStorage["query"], params: params_obj };
        if (sessionStorage["load_type"] != "org-chart") {
          console.log("Entering here because load type is not org chart but it is::", sessionStorage["load_type"]);
          new Query().callBackendQueryExecuteOnResponse(query_obj, user_input);
          // Now going to execute actions to call count query obj. Do it only for those queries where a count is expected. Might have to change this criteria in future
          if ((sessionStorage["raw_string_query_input"] == "") & (JSON.parse(sessionStorage["query"])["industry_category"].length == 0)) {
            new Query().setUpCountQueryResults();
          }
        } else {
          console.log("Entering here because load type is org chart::", sessionStorage["load_type"]);
          if (sessionStorage["current_focus"] == "orgcharts") {
            var parsed_flask_jinja_obj = JSON.parse(document.getElementById("org_data").getAttribute("data-row"));
            new DrawOrgCharts().setupOrgChartItems(parsed_flask_jinja_obj);
          } else {
            new Query().callBackendQueryExecuteOnResponse(query_obj, user_input);
            // Now going to execute actions to call count query obj
            if (sessionStorage["raw_string_query_input"] == "") {
              new Query().setUpCountQueryResults();
            }
          }
        }
      } else {
        // document.getElementById('header_element').innerHTML = ''
        new Query().ifYoucanSetupSearchImageonRightSide();
        // console.log("Session Storage is blank or company ID is undefined");
      }
    } else if (user_input == "raw_string_query_input") {
      var params_obj = updateParamsObj("raw_string_query_input");
      // updateStorageToken(node, 'raw_string_query_input')
      var query_obj = { query: sessionStorage["query"], params: params_obj };
      new Query().callBackendQueryExecuteOnResponse(query_obj, user_input);
    } else if (user_input == "boolean_keywords_string") {
      var params_obj = updateParamsObj("boolean_keywords_string");
      var query_obj = { query: sessionStorage["query"], params: params_obj };
      var user_input = "boolean_keywords_string";
      var node = myDiagram.findNodeForKey(sessionStorage["selectedNodeKey"]);
      updateStorageToken(node, "boolean_keywords_string");
      var params_obj = updateParamsObj("button_query_show_results");
      var query_obj = { query: sessionStorage["query"], params: params_obj };
      new Query().callBackendQueryExecuteOnResponse(query_obj, user_input);
    } else if (user_input == "fetch_people_results_consume_credits") {
      console.log("This is the data source selected::", sessionStorage["data_source"]);
      if (sessionStorage["query"] != blank_session_storage_obj || sessionStorage["company_id"] != undefined) {
        console.log("Tokens list is not equal to blank session Object");
        new Query().ifYouCanSetupLoadersinTheRightSide();
        console.log("sending query for ajax query inside second in fetch_people_results_consume_credits ");
        var params_obj = updateParamsObj("ajax_query");
        var query_obj = { query: sessionStorage["query"], params: params_obj };
        sessionStorage["sample_people_data"] = "false";
        // if (sessionStorage['load_type']!='org-chart'){
        var user_input = undefined;
        new Query().callBackendQueryExecuteOnResponse(query_obj, user_input);
        //
        // }
        // sessionStorage['sample_people_data'] = 'true'
      } else {
        console.log("Session Storage is blank or company ID is undefined");
      }
    } else if (user_input == "locations_dropdown1" || user_input == "locations_dropdown2" || user_input == "locations_dropdown3") {
      if (user_input == "locations_dropdown1") {
        document.getElementById("modal_locations_dropdown1").innerHTML = loader2;
      } else if (user_input == "locations_dropdown2") {
        document.getElementById("modal_locations_dropdown2").innerHTML = loader2;
      } else if (user_input == "locations_dropdown3") {
        document.getElementById("modal_locations_dropdown3").innerHTML = loader2;
      }
      if (sessionStorage["selectFunctionsTreeFunctionsRootItem"] != "" || sessionStorage["selectFunctionsTreeFunctionsItem"] != "" || sessionStorage["selectGradesItem"] != "") {
        console.log("Do nothing but just load the dropdown twos. No changing the storage tokens please");
      } else {
        console.log("User input is locations_dropdown");
        console.log(user_input);
        var node = myDiagram.findNodeForKey(sessionStorage["selectedNodeKey"]);
        updateStorageToken(node, "fetch_query_locations_dropdown");
        var params_obj = updateParamsObj(user_input);
        var node_query = { query: sessionStorage["query"], params: params_obj };
        console.log(node_query);
        var query_obj = node_query;
      }
      // Removing the node != null condition. Its likely that the node is going to be null sometimes. Lets see this temporarily
      // if (node !== null) {
      // callBackendQueryExecuteOnResponse(query_obj, user_input)
      if (user_input == "locations_dropdown1") {
        var countries_arr = new DrawOrgCharts().getAllCountriesFromLocationAnalytics();
        new LoadDataPeopleCompaniesOrgCharts().loadLocationsDropdown1(countries_arr);
      }
      if (user_input == "locations_dropdown2") {
        var country_selected = sessionStorage["locations_dropdown1"];
        var regions_arr = new DrawOrgCharts().getRegionsFromCountry(country_selected);
        new LoadDataPeopleCompaniesOrgCharts().loadLocationsDropdown2(regions_arr);
      }
      if (user_input == "locations_dropdown3") {
        var country_selected = sessionStorage["locations_dropdown1"];
        var region_selected = sessionStorage["locations_dropdown2"];
        var localities_arr = new DrawOrgCharts().getLocalitiesfromCountryAndRegion(country_selected, region_selected);
        new LoadDataPeopleCompaniesOrgCharts().loadLocationsDropdown3(localities_arr);
      }
      // }
    } else if (user_input == "cost_credits") {
      console.log("User input is cost_credits");
      console.log(user_input);
      if (sessionStorage["current_focus"] == "orgcharts") {
        document.getElementById("cost_of_credits_org_chart").innerHTML = '<div style="width:100%;text-align:center; padding:10px"><img style="width:30px;" src="/static/img/new_loading2.gif"/></div> ';
        if (sessionStorage["selectFunctionsTreeFunctionsRootItem"] != "" || sessionStorage["selectFunctionsTreeFunctionsItem"] != "" || sessionStorage["selectGradesItem"] != "") {
          console.log("This is the selcted using the main functions root");
        } else {
          try {
            if (typeof sessionStorage["selectedNodeKey"] != "undefined") {
              var node = myDiagram.findNodeForKey(sessionStorage["selectedNodeKey"]);
              console.log("This is the node::", node);
              if (node.data.std_function_category != "ceoassist") {
                // updateStorageToken(node, 'fetch_query_locations_dropdown')
                // Using the fetch_query_locations_dropdown to update storage token. Can create a new one also
                updateStorageToken(node, "fetch_query_locations_dropdown");
              } else {
                console.log("Waiting to do something??");
              }
            }
          } catch (error) {
            console.log("Error:", error);
          }
        }
      } else if (sessionStorage["current_focus"] == "people") {
        document.getElementById("cost_of_credits_people").innerHTML = loader2;
      } else if (sessionStorage["current_focus"] == "companies") {
        document.getElementById("cost_of_credits_companies").innerHTML = loader2;
      }
      var params_obj = updateParamsObj("cost_credits");
      var query_obj = { query: sessionStorage["query"], params: params_obj };
      console.log(JSON.parse(sessionStorage["query"]));

      new Query().callBackendQueryExecuteOnResponse(query_obj, user_input);
    } else if (user_input == "button_query_show_results") {
      console.log("User input is button_query_show_results");
      console.log(user_input);
      // called only from the fetch_node_results modal

      if (sessionStorage["selectFunctionsTreeFunctionsRootItem"] != "" || sessionStorage["selectFunctionsTreeFunctionsItem"] != "" || sessionStorage["selectGradesItem"] != "") {
        console.log("This is the selcted using the main functions root");
      } else {
        var node = myDiagram.findNodeForKey(sessionStorage["selectedNodeKey"]);
        updateStorageToken(node, "fetch_query_locations_dropdown");
      }

      var params_obj = updateParamsObj("button_query_show_results");

      var query_obj = { query: sessionStorage["query"], params: params_obj };

      // This node null query is an important bug which makes or breaks the whole damn org chart fetchiung thing for whole company. Not sure how and why. Took 3 hours and its 3:30 am
      // if (node !== null) {
      new Query().callBackendQueryExecuteOnResponse(query_obj, user_input);
      // }

      // Hide the modal later because it resets the functions and grades that have been setup initially
      try {
        $(fetch_node_results).modal("hide");
        // new Tokens().resetFunctionsGradesDropdown()
        $(waiting_results).modal("show");
      } catch (error) {
        console.log(" some error::", error);
      }
      delete node?.data?.total_people;
    } else if (user_input == "contact_info") {
      sessionStorage["contact_info"] = "true";
      var params_obj = updateParamsObj();
      var query_obj = { query: sessionStorage["query"], params: params_obj };
      console.log(JSON.parse(sessionStorage["query"]));

      new Query().callBackendQueryExecuteOnResponse(query_obj, user_input);
    } else if (user_input == "contact_info_org_charts") {
      sessionStorage["contact_info"] = "true";
      var params_obj = updateParamsObj();
      var query_obj = { query: sessionStorage["query"], params: params_obj };
      new Query().callBackendQueryExecuteOnResponse(query_obj, user_input);
    }
  }
}


export { selectColumn, ProcessNodesStates, Query, callBodyOnloadFunction, comboTree1, org_chart_filters_obj, company_filters_obj, people_filters_obj };
if (typeof window !== 'undefined') {
  window.selectColumn = selectColumn;
  window.ProcessNodesStates = ProcessNodesStates;
  window.Query = Query;
  window.callBodyOnloadFunction = callBodyOnloadFunction;
  window.comboTree1 = comboTree1;
  window.org_chart_filters_obj = org_chart_filters_obj;
  window.company_filters_obj = company_filters_obj;
  window.people_filters_obj = people_filters_obj;
}
